import React from 'react'

const TablaMedicoModificarProcedimiento = ({item, passModiMedico}) => {
  const dataMedico={
    codigoMedico:item.MMCODM,
    nombreMedico:item.MMNomM,
    codigoEspecialidad: item.MECodE,
    nombreEspecialidad: item.MENomE
  }
  const handleOnclickMedico=()=>{
    passModiMedico(dataMedico)
  }
  return (
    <tr className="border-b"  >
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        <button
            onClick={handleOnclickMedico}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
    <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MMCODM}</td>
    <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.MMCedM}</td>   
    <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.MMNomM}</td>   
    <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.MENomE}</td>  
  </tr>
  )
}

export default TablaMedicoModificarProcedimiento